var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2204_130",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2204_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.62495 22.0001C4.35828 22.0001 4.11662 21.8918 3.89995 21.6751C3.68328 21.4584 3.57495 21.2168 3.57495 20.9501V18.3251C3.57495 16.8251 4.04162 15.5001 4.97495 14.3501C5.90828 13.2001 7.10828 12.4668 8.57495 12.1501C7.90828 12.6168 7.39162 13.2043 7.02495 13.9126C6.65828 14.6209 6.47495 15.3834 6.47495 16.2001V20.9501C6.47495 21.1334 6.49995 21.3168 6.54995 21.5001C6.59995 21.6834 6.68328 21.8501 6.79995 22.0001H4.62495ZM8.29995 22.0001C8.01662 22.0001 7.77078 21.8959 7.56245 21.6876C7.35412 21.4793 7.24995 21.2334 7.24995 20.9501V16.2001C7.24995 15.0334 7.66245 14.0418 8.48745 13.2251C9.31245 12.4084 10.3083 12.0001 11.475 12.0001H16.2C17.3666 12.0001 18.3583 12.4084 19.175 13.2251C19.9916 14.0418 20.4 15.0334 20.4 16.2001V17.8001C20.4 18.9668 19.9916 19.9584 19.175 20.7751C18.3583 21.5918 17.3666 22.0001 16.2 22.0001H8.29995ZM12 9.90008C10.9 9.90008 9.96662 9.51675 9.19995 8.75008C8.43328 7.98342 8.04995 7.05008 8.04995 5.95008C8.04995 4.85008 8.43328 3.91675 9.19995 3.15008C9.96662 2.38342 10.9 2.00008 12 2.00008C13.1 2.00008 14.0333 2.38342 14.8 3.15008C15.5666 3.91675 15.95 4.85008 15.95 5.95008C15.95 7.05008 15.5666 7.98342 14.8 8.75008C14.0333 9.51675 13.1 9.90008 12 9.90008Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsWhite);
export default __webpack_public_path__ + "static/media/ContactsWhite.31d42b38fa379335674a6ddf6e3f0601.svg";
export { ForwardRef as ReactComponent };